
export const ADMIN_SETTING_LIST_CHANGE = 'ADMIN_SETTING_LIST_CHANGE';

export const ADMIN_SETTING_ITEM_CHANGE = 'ADMIN_SETTING_ITEM_CHANGE';


// WEBPACK FOOTER //
// ./src/store/Admin/modules/Settings/types.js